// extracted by mini-css-extract-plugin
export default {"container":"InfoStats-module__container__C0I8V","icon":"InfoStats-module__icon__nYUWN","label":"InfoStats-module__label__5ue3+","value":"InfoStats-module__value__9Avcy"};